import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  ClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
};

const userPool = new CognitoUserPool(poolData);

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ status: "SIGNED_IN", session }),
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => {
        // Cognito returns these on the challenge, but they're not something the
        // user is choosing here — strip the read-only/verification fields, and
        // `email` itself (Cognito rejects resubmitting an already-verified email
        // during this challenge, even unchanged, with "Cannot modify an already
        // provided email"), so completeNewPasswordChallenge doesn't try to
        // resubmit any of them.
        const attributesToSubmit = { ...userAttributes };
        delete attributesToSubmit.email_verified;
        delete attributesToSubmit.phone_number_verified;
        delete attributesToSubmit.email;
        resolve({ status: "NEW_PASSWORD_REQUIRED", cognitoUser: user, userAttributes: attributesToSubmit });
      },
      totpRequired: () => reject(new Error("MFA code required — MFA challenge UI is not yet wired up in this build.")),
    });
  });
}

export function completeNewPassword(cognitoUser, newPassword, userAttributes) {
  return new Promise((resolve, reject) => {
    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: (session) => resolve(session),
      onFailure: (err) => reject(err),
    });
  });
}

export function currentSession() {
  return new Promise((resolve, reject) => {
    const user = userPool.getCurrentUser();
    if (!user) {
      resolve(null);
      return;
    }
    user.getSession((err, session) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(session && session.isValid() ? session : null);
    });
  });
}

export function signOut() {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
}
